import { render } from "./InputFoto.vue?vue&type=template&id=49aec400&scoped=true"
import script from "./InputFoto.vue?vue&type=script&lang=js"
export * from "./InputFoto.vue?vue&type=script&lang=js"

import "./InputFoto.vue?vue&type=style&index=0&id=49aec400&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aec400"]])

export default __exports__